// src/pages/Login/SellerFarmerLogin.js
import React from 'react';
import Login from '../../components/Login/Login';

const SellerFarmerLogin = () => {
  return <Login role="seller-farmer" />;
};

export default SellerFarmerLogin;
